import React from 'react'
import { useGetAlertQuery } from '../../redux/services/AlertService'
import DataTable from 'react-data-table-component'
import CustomPagination from '../../components/CustomPagination';
import useLiveDataTable from '../../hooks/useLiveDataTable';
import moment from 'moment';

const DriverAlert = ({ id }) => {
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler
    } = useLiveDataTable();

    const { data: data2, isLoading, isFetching, refetch } = useGetAlertQuery(id)
    const alerts = data2?.response?.data?.data
    const total = data2?.response?.data?.total;

    const showStatusColor = (days) => {
        if (days == 0) {
            return 'bg-danger'
        } else if (days == 10) {
            return 'bg-warning'
        } else if (days == 20) {
            return 'bg-info'
        } else if (days == 30) {
            return 'bg-success'
        }
    }

    return (
        <>
            <div className="single-data mt-2">
                <h5 className="text-left">Driver Alerts</h5>
                {/* <DataTable
                    columns={[
                        {
                            name: 'Name',
                            selector: row => row.name,
                            sortable: true,
                        },
                        {
                            name: 'Alert 1 Date',
                            selector: row => row.alert1Date,
                            sortable: true,
                        },
                        {
                            name: 'Alert 2 Date',
                            selector: row => row.alert2Date,
                            sortable: true,
                        },
                        {
                            name: 'Alert 3 Date',
                            selector: row => row.alert3Date,
                            sortable: true,
                        }
                    ]}
                    data={data3}
                    customStyles={customTableStyles}
                    pagination={true}
                /> */}


                <CustomPagination
                    isFetching={isFetching}
                    data={alerts}
                    total={total}
                    onChangePage={handlePageChange} // Handle page change
                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                    paginationDefaultPage={currentPage} // Set the current page

                    columns={[
                        {
                            name: 'Name',
                            selector: row => row.name,
                            sortable: true,
                            width: '25%'
                        },
                        {
                            name: 'Expiry Date',
                            selector: row => (
                                <>
                                    <span class={`badge ${showStatusColor(parseInt(row.minus_days))}`}>{row.expiry}</span>
                                </>
                            ),
                            sortable: true,
                        },
                        {
                            name: 'Message',
                            selector: row => row.message,
                            sortable: true,
                            width: '30%'
                        },
                        {
                            name: 'Minus Reminder Date',
                            selector: row => (
                                <>
                                    <span class={`badge ${showStatusColor(parseInt(row.minus_days))}`}>{row.minus_days} Days</span>
                                </>
                            ),
                            sortable: true,
                        },
                        {
                            name: 'Alert forward Date',
                            selector: row => <>{moment(row.expiry).subtract(row.minus_days, 'days').format('YYYY-MM-D')}</>,
                            sortable: true,
                        },
                        // {
                        //     name: 'Actions',
                        //     cell: (row, i) => {
                        //         return (
                        //             <div className="hstack gap-1 fs-1">
                        //                 <button
                        //                     aria-label="view"

                        //                     className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                        //                 >
                        //                     <i className="ri-eye-fill" />
                        //                 </button>
                        //                 <button
                        //                     aria-label="edit"
                        //                     // 

                        //                     className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                        //                 >
                        //                     <i className="ri-edit-line" />
                        //                 </button>
                        //                 <a
                        //                     aria-label="delete"

                        //                     className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                        //                 >
                        //                     <i className="ri-delete-bin-7-line" />
                        //                 </a>
                        //             </div>
                        //         )
                        //     },
                        //     ignoreRowClick: true,
                        //     allowOverflow: true,
                        //     button: true,
                        //     width: '220px'
                        // },
                    ]}
                />
            </div>
        </>
    )
}

export default DriverAlert